<div *ngIf="model">
    <ms-help-box
        class="best-odds-container"
        *ngIf="isBOGHelpBoxVisible"
        [boxType]="'bestoddsguarantee'"
        (closeButtonClick)="onBOGHelpBoxClose()"></ms-help-box>
    <ms-crm-promotion-container *ngIf="crmBannerPromotions.length" [promotions]="crmBannerPromotions"></ms-crm-promotion-container>
    <ms-next-races [nextFixtures]="nextFixtures"></ms-next-races>
    <ms-day-of-race-lobby *ngIf="model.fixtures.length" [dayOfRace]="model" [filter]="today" [sportId]="sportId"></ms-day-of-race-lobby>
    <ms-error
        *ngIf="!model.fixtures.length"
        [links]="false"
        [message]="sitecore.horseRacing.tournaments.ErrNoTodayRaces"
        [severity]="'info'"></ms-error>
</div>
